import { render, staticRenderFns } from "./GzBizSidLabel.vue?vue&type=template&id=87e82a7e&scoped=true&"
import script from "./GzBizSidLabel.vue?vue&type=script&lang=js&"
export * from "./GzBizSidLabel.vue?vue&type=script&lang=js&"
import style0 from "./GzBizSidLabel.vue?vue&type=style&index=0&id=87e82a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e82a7e",
  null
  
)

export default component.exports